import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UserService } from '@core/services/user/user.service';
import { UserModel } from '@shared/models/user.model';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { NotificationSocket } from '@shared/services/websocket/custom_sockets/notification.socket';
import { BehaviorSubject } from 'rxjs';
import { NotificationComponent } from '@shared/components/notification/notification.component';
import { ToastService } from '@shared/services/toast/toast.service';
import { environment } from '../../../../environments/environment';
import { TranslocoService } from '@jsverse/transloco';
import { CookiesService } from '@core/services/cookies/cookies.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() toggleSidebar: EventEmitter<void> = new EventEmitter<void>();
  public user$: BehaviorSubject<UserModel | null> =
    new BehaviorSubject<UserModel | null>(null);
  public notificationsCounter$: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private router: Router,
    private notificationSocket: NotificationSocket,
    private toast: ToastService,
    public transcolo: TranslocoService,
    private cookieService: CookiesService
  ) {
    this.userService.userInfo$.subscribe((value) => {
      this.user$.next(value);
    });
  }

  public ngOnInit(): void {
    this.notificationSocket.on('NotificationState', (response: any) => {
      this.notificationSocket.notification$.next(response.reverse());
      const counter = response.filter(
        (notification: any) => !notification.isViewed
      ).length;
      this.notificationsCounter$.next(counter);
    });
    this.notificationSocket.on('Notification', (response: any) => {
      if (
        !this.router.url.includes('notifications') &&
        response &&
        response.text
      ) {
        this.toast.openFromComponent(
          NotificationComponent,
          response.text,
          response.text,
          response
        );
      }
    });
  }

  public changeLanguage(lang: string): void {
    this.transcolo.setActiveLang(lang);
    this.cookieService.setCookie(
      'language',
      lang,
      environment.production ? '.stalcraft.trade' : 'localhost'
    );
    if (this.authService.isAuthenticated$.value) {
      const settings = this.userService.userInfo$.value!.settings;
      const languageIndex = settings.findIndex((str: string) =>
        str.includes('language')
      );
      if (languageIndex === -1) {
        settings.push('language.' + lang);
      } else {
        settings[languageIndex] = 'language.' + lang;
      }
      this.userService.changeSettings(settings).subscribe();
    }
  }

  public goTo(url: string): void {
    this.router.navigate([url]);
  }

  public logOut(): void {
    this.authService.signOut();
  }
}
